import { createSelector } from '@ngrx/store';
import { featureKey, TeamManagementState } from './team-management.reducer';
import { TeamMemberLevel } from '../models/team-member';

export const selectRoles = (level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.roles[level],
  );

export const selectLoadingRoles = (level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.loadingRoles[level],
  );

export const selectRolesError = (level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.rolesError[level],
  );

export const selectAllTeams = (entityId: string, level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.teams[entityId]?.[level] ?? {},
  );

export const selectTeams = (entityId: string, level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.teams?.[entityId]?.[level] ?? {},
  );

export const selectLoading = (entityId: string, level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.loading[entityId]?.[level] ?? false,
  );

export const selectError = (entityId: string, level: TeamMemberLevel) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.errors[entityId]?.[level] ?? null,
  );

export const selectDeleteTeamMemberError = (memberId: string) =>
  createSelector(
    (state: any) => state[featureKey],
    (teamManagementState: TeamManagementState) =>
      teamManagementState.deleteTeamMemberError[memberId] ?? null,
  );

export const selectCreateTeamMemberLoading = createSelector(
  (state: any) => state[featureKey],
  (teamManagementState: TeamManagementState) =>
    teamManagementState.savingTeamMember,
);

export const selectCreateTeamMemberError = createSelector(
  (state: any) => state[featureKey],
  (teamManagementState: TeamManagementState) =>
    teamManagementState.savingTeamMemberError,
);

export const selectTeamMemberLoadingOrError = createSelector(
  selectCreateTeamMemberLoading,
  selectCreateTeamMemberError,
  (loading, error) => ({ error, loading }),
);
